<template>
  <div>
    <h1>語系</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
